import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { itemsOnPage } from 'features/bonusProgram/data';
import { actions } from 'features/bonusProgram';

const useCurrentGifts = () => {
  const dispatch = useDispatch();
  const { items, count } = useSelector(s => s.bonusProgram.currentGifts);
  const { currentGiftsUpdateTrigger } = useSelector(s => s.bonusProgram);

  const [state, setState] = useState({
    page: 0,
    itemsOnPage,
  });

  const handlePageChange = page => setState(ps => ({ ...ps, page }));
  const handleItemsOnPageChange = itemsOnPage => setState(ps => ({ ...ps, itemsOnPage }));

  const activeItemsOnPage = state.itemsOnPage.filter(v => v.active)?.[0]?.value ?? 10;
  const pages = Math.ceil(count / activeItemsOnPage);

  useEffect(() => {
    dispatch(actions.getCurrentGifts({ page: state.page, count: activeItemsOnPage }));
  }, [currentGiftsUpdateTrigger, activeItemsOnPage, state.page]);

  return ({
    values: {
      state,
      items,
      pages,
      count,
      activeItemsOnPage,
    },
    handlers: {
      handlePageChange,
      handleItemsOnPageChange,
    }
  });
};

export default useCurrentGifts;
